<script lang="ts">
    import {fade} from 'svelte/transition';

    import {ANALYTICS, FLAGS} from 'general/constants';
    import {modal, dyData} from 'general/store';
    import {ANIMATION_DURATION} from 'general/constants';
    import {pushPopupEvent} from 'general/libs/pushDataLayer';

    import s from './style.module.css';

    export let theme = 'dark';
    export let delay = 3000;
    export let side: 'right' | 'left';
    export let noHeader = false;

    const clickHandler = () => {
        pushPopupEvent(ANALYTICS.POPUP_SKIPPED_SMS);
        modal.changeState('typ');
    };
</script>

<button
    in:fade|global={{
        duration: $modal.isFirstExperience ? ANIMATION_DURATION.CLOSE_BUTTON : 0,
        delay: $modal.isFirstExperience && $dyData.flag !== FLAGS.CROSS_WITHOUT_DELAY ? delay : 0,
    }}
    out:fade={{duration: 0}}
    class="{s.skipBtn} {s[theme] || ''} {s[side] || ''}"
    class:s.noHeader={noHeader}
    class:s.closeButtonColor={$dyData.isSmallerScreen}
    type="button"
    on:introend={modal.setFirstExperience}
    on:click={clickHandler}
    aria-label="Skip step"
>
    <span class={s.skipText}>Later</span>
</button>
